// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b1gA","label":"styles_label__2wQ2w"};